import { render } from "./LanguageLayout.vue?vue&type=template&id=06ca9048"
import script from "./LanguageLayout.vue?vue&type=script&lang=js"
export * from "./LanguageLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__